import { useEffect, useRef, useState } from 'react';

/**
 * Détecte une nouvelle version en relisant /version.json.
 * Vérifie : au démarrage, sur focus d'onglet, et toutes les 5 minutes.
 * La version dans version.json doit être un timestamp Unix (Date.now()).
 * Elle est mise à jour automatiquement à chaque build via le script prebuild.
 */
export function useVersionCheck() {
  const initialVersion = useRef(null);
  const [updateAvailable, setUpdateAvailable] = useState(false);
  const bannerScheduled = useRef(false);

  const check = async () => {
    if (updateAvailable || bannerScheduled.current) return;
    try {
      const res = await fetch('/version.json?t=' + Date.now());
      if (!res.ok) return;
      const { version } = await res.json();
      if (initialVersion.current === null) {
        initialVersion.current = version;
        return;
      }
      if (version !== initialVersion.current) {
        bannerScheduled.current = true;
        setUpdateAvailable(true);
      }
    } catch (_) {}
  };

  useEffect(() => {
    // Lire la version initiale au démarrage
    check();

    // Revérifier sur focus d'onglet
    window.addEventListener('focus', check);

    // Polling toutes les 5 minutes (tab toujours active)
    const interval = setInterval(check, 3 * 60 * 1000);

    return () => {
      window.removeEventListener('focus', check);
      clearInterval(interval);
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return updateAvailable;
}
